import RecruiterCandidateSendSubmissionRound from './RecruiterCandidateSendSubmissionRound';
import { SendAssignmentToUserInput } from 'types';

const RecruiterCandidateSendAssignment = (props: {
	userId?: string;
	userName?: string;
	positionId?: string;
	isLoading?: boolean;
	onSubmit?: (data: SendAssignmentToUserInput) => void;
	onFinish?: () => void;
}) => <RecruiterCandidateSendSubmissionRound variant="assignment" {...props} />;

export default RecruiterCandidateSendAssignment;
